<template lang="pug">
    ib-col
        div(v-if="selectedTab === 'companies'")
            div(v-if="groupAssets === 'all'")
                SearchResultsCompanies
            div(v-else-if="prevAsset === 'etfs'")
                SearchResultsCompanies
            div(v-else-if="prevAsset === 'stocks'")
                SearchResultsGroups
        div(v-else)
            FilterOptions(@update="search")
            div(v-if="prevAsset === 'all'")
                SearchResultsCombined
            div(v-else-if="prevAsset === 'etfs'")
                SearchResultsETFs
            div(v-else-if="prevAsset === 'stocks'")
                SearchResults
</template>

<script>
import { mapState } from 'vuex';

import FilterOptions from './FilterOptions.vue';
import SearchResultsGroups from './SearchResultsGroups.vue';
import SearchResultsETFs from './SearchResultsETFs.vue';
import SearchResults from './SearchResults.vue';
import SearchResultsCombined from './SearchResultsCombined.vue';
import SearchResultsCompanies from './SearchResultsCompanies.vue';


export default {
    name: 'NewSearchResults',
    components: {
        FilterOptions,
        SearchResultsGroups,
        SearchResultsETFs,
        SearchResults,
        SearchResultsCombined,
        SearchResultsCompanies,
    },
    data() {
        return {
            prevAsset: null,
            groupAssets: null
        }
    },
    methods: {
        search() {
            console.debug('API Request');
        },
        currentAsset() {
            if (this.status === 'loading') {
                return this.prevAsset;
            }

            if (this.selectedAssets.length === 2) {
                this.prevAsset = 'all';
            } else {
                this.prevAsset = this.selectedAssets[0];
            }
            return this.prevAsset;
        },
        groupAsset() {
            let assetTypes = [];
            for(let i = 0; i < this.groups.length; i++){
                for(let j = 0; j < this.groups[i].companies.length; j++){
                    assetTypes.push(this.groups[i].companies[j].type);
                }   
            }
            if(assetTypes.includes('stocks') && assetTypes.includes('etfs')) {
                this.groupAssets = 'all';
            }
            return this.groupAssets;
        }
    },
    mounted() {
        this.prevAsset = this.currentAsset();
        this.groupAssets = this.groupAsset();
    },
    computed: {
        selectedAssets: function() {
            return this.$store.getters.selectedAssets;
        },
        ...mapState(['selectedTab','assets', 'status','groups'])
    },
    watch: {
        status: function() {
            this.currentAsset();
        }
    }
}
</script>

<style lang="less" scoped>
    .start-over {
        @media (min-width: 768px) {
            float: right;
        }
    }
</style>